import React, { Component } from 'react';

class TextInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.value,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.state.text = nextProps.value;
  }

  handleChange = e => {
    if(this.props.onChange) {
      this.props.onChange({target: {
        value:e.target.value,
        dataset: {extendedPropertyId:this.props.extendedPropertyId}
      }});
    }
    this.setState({ text: e.target.value });
  };

  render() {
    if(this.props.value==null) {
      return (
        <input
          onChange={this.handleChange}
          autoComplete="off"
          type="text"
          id={this.props.id}
          className="modal-input"
        />
      );
    }
    else {
      return (
        <input
          onChange={this.handleChange}
          autoComplete="off"
          value={this.state.text}
          type="text"
          id={this.props.id}
          className="modal-input"
        />
      );      
    }
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./source/client/components/common/extended_property/textInput.jsx